import { render, staticRenderFns } from "./information-center.vue?vue&type=template&id=eca80878&scoped=true"
import script from "./information-center.vue?vue&type=script&lang=js"
export * from "./information-center.vue?vue&type=script&lang=js"
import style0 from "./information-center.vue?vue&type=style&index=0&id=eca80878&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca80878",
  null
  
)

export default component.exports